export default __webpack_public_path__ + "ocr/worker.min-57d19e51143b1029a3c6d44692e7cf42.js";